import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { trim } from 'lodash';
import isEmail from 'validator/lib/isEmail';
import {
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { gql, useMutation } from '@apollo/client';
import getHelpfulErrorMessage from 'utils/getHelpfulErrorMessage';

const REMOVE_EMAIL_FROM_SUPPRESSION_LIST = gql`
  mutation RemoveEmailFromSesSuppressionList($input: RemoveEmailFromSesSuppressionListInput!) {
    removeEmailFromSesSuppressionList(input: $input)
  }
`;

const SuppressionList = ({ classes }) => {

  const [email, setEmail] = useState('');
  const [alert, setAlert] = useState(null);
  const [removeEmail, { loading }] = useMutation(REMOVE_EMAIL_FROM_SUPPRESSION_LIST);

  const normalizedEmail = trim(email);
  const emailIsInvalid = normalizedEmail.length > 0 && !isEmail(normalizedEmail);

  const handleRemove = async () => {
    setAlert(null);
    if (!normalizedEmail || emailIsInvalid) {
      return;
    }
    try {
      await removeEmail({
        variables: {
          input: { email: normalizedEmail },
        },
      });
      setAlert({
        type: 'success',
        message: `Removed ${normalizedEmail} from AWS Suppression list`,
      });
      setEmail('');
    } catch (e) {
      setAlert({
        type: 'error',
        message: getHelpfulErrorMessage(e),
      });
    }
  };

  return (
    <div>

      <Typography variant="h6">
        Suppression list
      </Typography>

      {alert && (
        <Alert
          severity={alert.type}
          className={classes.alert}
          onClose={() => setAlert(null)}
        >
          {alert.message}
        </Alert>
      )}

      <Card>
        <CardContent>
          <div className={classes.form}>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={classes.input}
              error={emailIsInvalid}
              helperText={
                emailIsInvalid ? 'Enter a valid email address' : undefined
              }
            />

            <Button
              variant="contained"
              color="primary"
              className={classes.submitButton}
              onClick={handleRemove}
              disabled={loading || !normalizedEmail || emailIsInvalid}
            >
              Remove from AWS Suppression List
            </Button>
          </div>
        </CardContent>
      </Card>

    </div>
  );

};

const styles = (theme) => ({
  alert: {
    marginBottom: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  input: {
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
      flex: 1,
      minWidth: 280,
      maxWidth: 440,
    },
  },
  submitButton: {
    alignSelf: 'stretch',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'auto',
      flexShrink: 0,
      marginTop: theme.spacing(1.25),
    },
  },
});

export default withStyles(styles)(SuppressionList);
